import path from 'path';
import { isExternal } from '@/utils/validate';
import Item from './Item';
import AppLink from './Link';
export default {
  name: 'SidebarItem',
  components: {
    Item,
    AppLink
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    parent: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    this.onlyOneChild = null;
    return {
      subExpanded: false
    };
  },
  computed: {
    sidebarActiveName() {
      const route = this.$route;
      if (route.query && route.query.route) {
        try {
          return JSON.parse(route.query.route).name;
        } catch (e) {
          return route.name;
        }
      }
      if (route.meta && route.meta.activeMenu) {
        return route.meta.activeMenu;
      }
      return route.name;
    },
    hasActiveDescendant() {
      return this.item.children && this.item.children.length ? this.item.children.some(ch => !ch.hidden && this.routeMatchesItem(ch)) : false;
    }
  },
  watch: {
    hasActiveDescendant: {
      handler(val) {
        if (val) this.subExpanded = true;
      },
      immediate: true
    }
  },
  methods: {
    toggleSub() {
      this.subExpanded = !this.subExpanded;
    },
    isLeafActive(routeItem) {
      if (!routeItem || !routeItem.name) return false;
      return routeItem.name === this.sidebarActiveName;
    },
    routeMatchesItem(routeItem) {
      if (this.isLeafActive(routeItem)) return true;
      if (routeItem.children && routeItem.children.length) {
        return routeItem.children.some(ch => !ch.hidden && this.routeMatchesItem(ch));
      }
      return false;
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        }
        this.onlyOneChild = item;
        return true;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      if (showingChildren.length === 0) {
        this.onlyOneChild = {
          ...parent,
          path: '',
          noShowingChildren: true
        };
        return true;
      }
      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }
};